// @ts-nocheck
import { Column } from "react-table";
import { TitleCell } from "./TitleCell";
import { UserCustomHeader } from "./CustomHeader";
import moment from "moment";

const orderDetailListColumns: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Order Number" className="min-w-50px" />
    ),
    id: "order_number",
    Cell: ({ row }) => <TitleCell userObj={row.original?.order_number || "-"} />,
  },


  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Article Code" className="min-w-50px" />
    ),
    id: "article_code",
    Cell: ({ row }) => <TitleCell userObj={row.original?.article_code || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Ordered Quantity" className="min-w-50px" />
    ),
    id: "ordered_quantity",
    Cell: ({ row }) => <TitleCell userObj={row.original?.ordered_quantity || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Arrived Quantity" className="min-w-50px" />
    ),
    id: "quantity_arrived",
    Cell: ({ row }) => <TitleCell userObj={row.original?.quantity_arrived || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Unit Price" className="min-w-50px" />
    ),
    id: "unit_price",
    Cell: ({ row }) => <TitleCell userObj={row.original?.unit_price || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Currency" className="min-w-50px" />
    ),
    id: "currency",
    Cell: ({ row }) => <TitleCell userObj={row.original?.currency || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Production Lot" className="min-w-50px" />
    ),
    id: "production_lot",
    Cell: ({ row }) => <TitleCell userObj={row.original?.production_lot || "-"} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Order Status" className="min-w-50px" />
    ),
    id: "status",
    Cell: ({ row, data }) => {
      const status = data[row.index]?.status || "Unknown";

      const bgColor =
        status.toLowerCase() === "open" || status.toLowerCase() === "aprire" ? "#007bff" :
          status.toLowerCase() === "close" || status.toLowerCase() === "chiuso" ? "#dc3545" :
            "#6c757d";

      const badgeStyle = {
        display: "inline-block",
        padding: "4px 12px",
        borderRadius: "12px",
        backgroundColor: bgColor,
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        minWidth: "70px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        transition: "all 0.2s ease",
      };

      return <span style={badgeStyle}>{status}</span>;
    },
  },



  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title=" Requested Date" className="min-w-50px" />
    ),
    id: "requested_date",
    Cell: ({ row }) => {
      const date = row.original?.requested_date;
      return <TitleCell userObj={date ? moment(date).format("YYYY/MM/DD") : "-"} />;
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Arrival Date" className="min-w-50px" />
    ),
    id: "arrivalDate",
    Cell: ({ row }) => {
      const date = row.original?.arrivalDate;
      return <TitleCell userObj={date ? moment(date).format("YYYY/MM/DD") : "-"} />;
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title="Shipment Status"
        className="min-w-50px"
      />
    ),
    id: "deliveryStatus",
    Cell: ({ row, data }) => {
      const status = data[row.index]?.deliveryStatus || "Unknown";

      let displayStatus = status;
      let bgColor = "#6c757d";

      if (status === "On Time") {
        displayStatus = "On Time";
        bgColor = "#28a745";
      } else if (status === "Late") {
        displayStatus = "Late";
        bgColor = "#fd7e14";
      } else if (status === "Order to ship") {
        displayStatus = "Order to ship";
        bgColor = "#17a2b8";
      }

      const badgeStyle = {
        display: "inline-block",
        padding: "4px 12px",
        borderRadius: "12px",
        backgroundColor: bgColor,
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        minWidth: "150px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        transition: "all 0.2s ease",
      };

      return <span style={badgeStyle}>{displayStatus}</span>;
    },
  },

];

export { orderDetailListColumns };
